import React from 'react';
import { Button, Tooltip } from 'antd';
import { hasPermission, needsConfirmation, logAudit, User } from '../../utils/permissions';

interface PermissionButtonProps {
  user: User | null;
  page: string;
  action: string;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
  danger?: boolean;
  icon?: React.ReactNode;
  tooltip?: string;
  confirmMessage?: string;
  [key: string]: any;
}

const PermissionButton: React.FC<PermissionButtonProps> = ({
  user,
  page,
  action,
  children,
  onClick,
  disabled = false,
  type = 'default',
  danger = false,
  icon,
  tooltip,
  confirmMessage,
  ...props
}) => {
  const hasAccess = hasPermission(user, page, action);
  
  if (!hasAccess) {
    return (
      <Tooltip title="您没有权限执行此操作">
        <Button
          {...props}
          disabled
          type={type}
          danger={danger}
          icon={icon}
        >
          {children}
        </Button>
      </Tooltip>
    );
  }

  const handleClick = () => {
    if (user) {
      logAudit(user, page, action);
    }
    
    if (needsConfirmation(page, action)) {
      const message = confirmMessage || `确定要执行${action}操作吗？`;
      if (window.confirm(message)) {
        onClick?.();
      }
    } else {
      onClick?.();
    }
  };

  const button = (
    <Button
      {...props}
      disabled={disabled}
      type={type}
      danger={danger}
      icon={icon}
      onClick={handleClick}
    >
      {children}
    </Button>
  );

  if (tooltip) {
    return <Tooltip title={tooltip}>{button}</Tooltip>;
  }

  return button;
};

export default PermissionButton;
